import React from "react";
import { FormattedMessage } from "react-intl";
import SharedText from "../../../shared/SharedText/SharedText";
import "./publishers.scss";
import { ReactComponent as Publishers1 } from "../../../../assets/mobile/publishers1.svg";
import { ReactComponent as Publishers2 } from "../../../../assets/mobile/publishers2.svg";
import StyledLink from "../../../shared/StyledLink/StyledLink";
import { BsChevronRight } from "react-icons/bs";

const publishersData = [
  {
    icon: <Publishers1 />,
    name: "Ayde Market",
    text: (
      <FormattedMessage id="publishers1-text" defaultMessage="E-commerce" />
    ),
    to: "/",
  },

  {
    icon: <Publishers2 />,
    name: "Herby",
    text: (
      <FormattedMessage id="publishers2-text" defaultMessage="E-commerce" />
    ),
    to: "/",
  },
];

const Publishers = () => {
  return (
    <div className="mobile-publishers">
      <div className="right">
        <div className="img" />
        <div className="programs">
          <p className="def-text gray">
            <FormattedMessage id="programs" defaultMessage="Programs" />
          </p>
          <h3 className="small-title">
            <FormattedMessage
              id="all-categories"
              defaultMessage="All Categories"
            />
          </h3>
          {publishersData.map((props, i) => {
            return (
              <div className="programsCard" key={i}>
                <div className="left-side">
                  <div className="icon">{props.icon}</div>

                  <div className="text1">
                    <p className="def-text">{props.name}</p>
                    <span>{props.name}</span>
                  </div>
                </div>

                <StyledLink
                  to={props.to}
                  styles="unstyled"
                  linkName={
                    <FormattedMessage id="view" defaultMessage="View" />
                  }
                  rightIcon={<BsChevronRight />}
                  linkColor="var(--main-color)"
                  rightIconColor="var(--main-color)"
                  rightIconSize="max(16px,1vw)"
                  fontWeight="600"
                />
              </div>
            );
          })}
        </div>
      </div>

      <SharedText
        title1={
          <FormattedMessage
            id="mobile-publishers-title"
            defaultMessage="For publishers"
          />
        }
        text1={
          <FormattedMessage
            id="mobile-publishers-text1"
            defaultMessage="The app offers our publishers detailed information about agencies and advertisers in the program details as well as direct registration for our partner programs. "
          />
        }
      />
    </div>
  );
};

export default Publishers;
